import throttle from 'lodash.throttle';
import { RefObject, useEffect, useState } from 'react';

export function useElementWidth(
  ref: RefObject<HTMLElement | null>,
  throttleValue: number = 0,
): number | undefined {
  const [width, setWidth] = useState<number | undefined>(undefined);

  useEffect(() => {
    const updateWidth = () => {
      if (ref.current) {
        setWidth(ref.current.getBoundingClientRect().width);
      }
    };

    const throttledUpdate = throttle(updateWidth, throttleValue);
    throttledUpdate();

    const resizeObserver = new ResizeObserver(throttledUpdate);
    const currentElement = ref.current;
    if (currentElement) {
      resizeObserver.observe(currentElement);
    }

    window.addEventListener('resize', updateWidth);

    return () => {
      if (currentElement) {
        resizeObserver.unobserve(currentElement);
      }
      window.removeEventListener('resize', updateWidth);
    };
  }, [ref]);

  return width;
}
